declare module '@mui/material/styles' {
  interface TypographyVariants {
    display: React.CSSProperties;
    t1: React.CSSProperties;
    t1Underline: React.CSSProperties;
    t2: React.CSSProperties;
    t2Underline: React.CSSProperties;
    t3: React.CSSProperties;
    t3Underline: React.CSSProperties;
    t4: React.CSSProperties;
    t5: React.CSSProperties;
    t6: React.CSSProperties;
    adfBody1: React.CSSProperties;
    body1Underline: React.CSSProperties;
    body1Italic: React.CSSProperties;
    body1Bold: React.CSSProperties;
    body2: React.CSSProperties;
    body2Underline: React.CSSProperties;
    body2Italic: React.CSSProperties;
    lead: React.CSSProperties;
    leadUnderline: React.CSSProperties;
    leadItalic: React.CSSProperties;
    quote1: React.CSSProperties;
    quote2: React.CSSProperties;
    stat: React.CSSProperties;
    nav1: React.CSSProperties;
    nav2: React.CSSProperties;
    nav3: React.CSSProperties;
    tab: React.CSSProperties;
    post: React.CSSProperties;
    title1: React.CSSProperties;
    title1Underline: React.CSSProperties;
    title2: React.CSSProperties;
    title2Underline: React.CSSProperties;
    title3: React.CSSProperties;
    title3Underline: React.CSSProperties;
    subtitle1: React.CSSProperties;
    subtitle1Italic: React.CSSProperties;
    subtitle2: React.CSSProperties;
    subtitle3: React.CSSProperties;
    link1: React.CSSProperties;
    link1Underline: React.CSSProperties;
    link2: React.CSSProperties;
    link2Underline: React.CSSProperties;
    link3: React.CSSProperties;
    link3Underline: React.CSSProperties;
    overline1: React.CSSProperties;
    overline2: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    display?: React.CSSProperties;
    t1?: React.CSSProperties;
    t1Underline?: React.CSSProperties;
    t2?: React.CSSProperties;
    t2Underline?: React.CSSProperties;
    t3?: React.CSSProperties;
    t3Underline?: React.CSSProperties;
    t4?: React.CSSProperties;
    t5?: React.CSSProperties;
    t6?: React.CSSProperties;
    adfBody1?: React.CSSProperties;
    body1Underline?: React.CSSProperties;
    body1Italic?: React.CSSProperties;
    body1Bold?: React.CSSProperties;
    body2?: React.CSSProperties;
    body2Underline?: React.CSSProperties;
    body2Italic?: React.CSSProperties;
    lead?: React.CSSProperties;
    leadUnderline?: React.CSSProperties;
    leadItalic?: React.CSSProperties;
    quote1?: React.CSSProperties;
    quote2?: React.CSSProperties;
    stat?: React.CSSProperties;
    nav1?: React.CSSProperties;
    nav2?: React.CSSProperties;
    nav3?: React.CSSProperties;
    tab?: React.CSSProperties;
    post?: React.CSSProperties;
    title1?: React.CSSProperties;
    title1Underline?: React.CSSProperties;
    title2?: React.CSSProperties;
    title2Underline?: React.CSSProperties;
    title3?: React.CSSProperties;
    title3Underline?: React.CSSProperties;
    subtitle1?: React.CSSProperties;
    subtitle1Italic?: React.CSSProperties;
    subtitle2?: React.CSSProperties;
    subtitle3?: React.CSSProperties;
    link1?: React.CSSProperties;
    link1Underline?: React.CSSProperties;
    link2?: React.CSSProperties;
    link2Underline?: React.CSSProperties;
    link3?: React.CSSProperties;
    link3Underline?: React.CSSProperties;
    overline1?: React.CSSProperties;
    overline2?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    // Turn off the built in MUI variants that we don't use.
    button: false;
    caption: false;
    overline: false;

    // ADF brand variants.
    display: true;
    t1: true;
    t1Underline: true;
    t2: true;
    t2Underline: true;
    t3: true;
    t3Underline: true;
    t4: true;
    t5: true;
    t6: true;
    body1: true;
    adfBody1: true;
    body1Underline: true;
    body1Italic: true;
    body1Bold: true;
    body2: true;
    body2Underline: true;
    body2Italic: true;
    lead: true;
    leadUnderline: true;
    leadItalic: true;
    quote1: true;
    quote2: true;
    stat: true;
    nav1: true;
    nav2: true;
    nav3: true;
    tab: true;
    post: true;
    title1: true;
    title1Underline: true;
    title2: true;
    title2Underline: true;
    title3: true;
    title3Underline: true;
    subtitle1: true;
    subtitle1Italic: true;
    subtitle2: true;
    subtitle3: true;
    link1: true;
    link1Underline: true;
    link2: true;
    link2Underline: true;
    link3: true;
    link3Underline: true;
    overline1: true;
    overline2: true;
  }
}

const sofia = '"sofia-pro", sans-serif';
const miller = 'miller-text, serif';

const FontWeight = {
  black: 900,
  extrabold: 800,
  bold: 700,
  semibold: 600,
  medium: 500,
  regular: 400,
  roman: 400,
} as const;
const md = '@media (min-width:900px)';

export const adfTypography = {
  fontFamily: sofia,

  display: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '40px',
    lineHeight: '40px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '85px', lineHeight: '80px', letterSpacing: '-1px' },
  },

  t1: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '36px',
    lineHeight: '38px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '64px', lineHeight: '60px' },
  },
  t1Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    textDecoration: 'underline',
    fontSize: '36px',
    lineHeight: '40px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '64px', lineHeight: '60px' },
  },

  t2: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '28px',
    lineHeight: '32px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '40px', lineHeight: '44px' },
  },
  t2Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    textDecoration: 'underline',
    fontSize: '28px',
    lineHeight: '32px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '40px', lineHeight: '44px' },
  },

  t3: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '0px',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '28px', lineHeight: '32px' },
  },
  t3Underline: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    textDecoration: 'underline',
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '0px',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '28px', lineHeight: '32px' },
  },

  t4: {
    fontFamily: sofia,
    fontWeight: FontWeight.extrabold,
    fontSize: '17px',
    lineHeight: '24px',
    letterSpacing: '0px',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '21px', lineHeight: '28px' },
  },

  t5: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '17px', lineHeight: '20px' },
  },

  t6: {
    fontFamily: sofia,
    fontWeight: FontWeight.bold,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
  },

  body1: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '17px',
    lineHeight: '24px',
    letterSpacing: '0px',
    [md]: { fontSize: '21px', lineHeight: '28px' },
  },
  body1Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    textDecoration: 'underline',
    fontSize: '17px',
    lineHeight: '24px',
    letterSpacing: '0px',
    [md]: { fontSize: '21px', lineHeight: '28px' },
  },
  body1Italic: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontStyle: 'italic',
    fontSize: '17px',
    lineHeight: '24px',
    letterSpacing: '0px',
    [md]: { fontSize: '21px', lineHeight: '28px' },
  },
  body1Bold: {
    fontFamily: sofia,
    fontWeight: FontWeight.extrabold,
    fontSize: '17px',
    lineHeight: '24px',
    letterSpacing: '0px',
    [md]: { fontSize: '21px', lineHeight: '28px' },
  },

  body2: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '17px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  body2Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    textDecoration: 'underline',
    fontSize: '17px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  body2Italic: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontStyle: 'italic',
    fontSize: '17px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },

  lead: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '0px',
    [md]: { fontSize: '40px', lineHeight: '48px' },
  },
  leadUnderline: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    textDecoration: 'underline',
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '0px',
    [md]: { fontSize: '40px', lineHeight: '48px' },
  },
  leadItalic: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontStyle: 'italic',
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '0px',
    [md]: { fontSize: '40px', lineHeight: '48px' },
  },

  quote1: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '0px',
    [md]: { fontSize: '40px', lineHeight: '56px' },
  },
  quote2: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '0px',
    [md]: { fontSize: '30px', lineHeight: '36px' },
  },

  stat: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    [md]: { fontSize: '85px', lineHeight: '80px' },
  },

  nav1: {
    fontFamily: sofia,
    fontWeight: FontWeight.medium,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '0px',
    [md]: { fontSize: '18px', lineHeight: '20px' },
  },
  nav2: {
    fontFamily: sofia,
    fontWeight: FontWeight.medium,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    [md]: { fontSize: '14px', lineHeight: '20px' },
  },
  nav3: {
    fontFamily: sofia,
    fontWeight: FontWeight.medium,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px',
    [md]: { fontSize: '12px', lineHeight: '16px' },
  },

  tab: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '36px',
    lineHeight: '40px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '64px', lineHeight: '60px' },
  },

  post: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '36px',
    lineHeight: '38px',
    letterSpacing: '0px',
    textTransform: 'capitalize',
    fontVariantNumericFigure: 'lining-nums',
    fontVariantNumericSpacing: 'proportional-nums',
    [md]: { fontSize: '60px', lineHeight: '68px' },
  },

  title1: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '24px',
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  title1Underline: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    textDecoration: 'underline',
    fontSize: '24px',
    lineHeight: '28px',
    letterSpacing: '0px',
  },

  title2: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  title2Underline: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    textDecoration: 'underline',
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0px',
  },

  title3: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  title3Underline: {
    fontFamily: miller,
    fontWeight: FontWeight.roman,
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px',
  },

  subtitle1: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  subtitle1Italic: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontStyle: 'italic',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
  },

  subtitle2: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  subtitle2Italic: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontStyle: 'italic',
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },

  subtitle3: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  subtitle3Italic: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px',
  },

  link1: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
  },
  link1Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
  },

  link2: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
  },
  link2Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
  },

  link3: {
    fontFamily: sofia,
    fontWeight: FontWeight.semibold,
    fontSize: '12px',
    lineHeight: '12px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
  },
  link3Underline: {
    fontFamily: sofia,
    fontWeight: FontWeight.semibold,
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '12px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
  },

  overline1: {
    fontFamily: sofia,
    fontWeight: FontWeight.regular,
    fontSize: '17px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },

  overline2: {
    fontFamily: sofia,
    fontWeight: FontWeight.black,
    fontSize: '13px',
    lineHeight: '16px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
  },
} as const;

export const typography = {
  ...adfTypography,

  h1: adfTypography.t1,
  h2: adfTypography.t2,
  h3: adfTypography.t3,
  h4: adfTypography.t4,
  h5: adfTypography.t5,
  h6: adfTypography.t6,
  body1: adfTypography.body2,
  adfBody1: adfTypography.body1,
  caption: adfTypography.subtitle3,
  overline: adfTypography.overline1,
  button: adfTypography.body2,
} as const;

export default typography;
